define.alias("shared/components/shared/post-tagging/badge", "calendar/components/shared/post-tagging/badge");